
export function slugify(str) {
  return String(str)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

const RAW_DEFAULT_GROUPS = [
  {
    label: "Business Cards",
    subs: [
      { label: "Business Cards",           cat: "Business Cards" },
      { label: "Specialty Business Cards", cat: "Specialty Business Cards" },
    ],
  },
  {
    label: "Print Products",
    subs: [
      { label: "Postcards",                 cat: "Postcards" },
      { label: "Flyers",                    cat: "Flyers" },
      { label: "Brochures",                 cat: "Brochures" },
      { label: "Bookmarks",                 cat: "Bookmarks" },
      { label: "Presentation Folders",      cat: "Presentation Folders" },
      { label: "Booklets",                  cat: "Booklets" },
      { label: "Magnets",                   cat: "Magnets" },
      { label: "Greeting Cards",            cat: "Greeting Cards" },
      { label: "Wall Calendars",            cat: "Wall Calendars" },
      { label: "Posters",                   cat: "Posters" },
      { label: "Door Hangers",              cat: "Door Hangers" },
      { label: "Digital Sheets",            cat: "Digital Sheets" },
      { label: "Folded Business Cards",     cat: "Folded Business Cards" },
      { label: "Tent Cards",                cat: "Tent Cards" },
      { label: "Plastic Cards",             cat: "Plastics" },
      { label: "Tear Cards",                cat: "Tear Cards" },
      { label: "Clings",                    cat: "Clings" },
    ],
  },
  {
    label: "Stationery",
    subs: [
      { label: "Letterhead",   cat: "Letterhead" },
      { label: "Envelopes",    cat: "Envelopes" },
      { label: "Notepads",     cat: "Notepads" },
      { label: "NCR Forms",    cat: "NCR Forms" },
      { label: "Supply Boxes", cat: "Supply Boxes" },
    ],
  },
  {
    label: "Large Format",
    subs: [
      { label: "Coroplast / Yard Signs", cat: "Coroplast Signs & Yard Signs" },
      { label: "Floor Graphics",         cat: "Floor Graphics" },
      { label: "Foam Board",             cat: "Foam Board" },
      { label: "Aluminum Signs",         cat: "Aluminum Signs" },
      { label: "Pull Up Banners",        cat: "Pull Up Banners" },
      { label: "Car Magnets",            cat: "Car Magnets" },
      { label: "Table Covers",           cat: "Table Covers" },
      { label: "Adhesive Vinyl",         cat: "Adhesive Vinyl" },
      { label: "Window Graphics",        cat: "Window Graphics" },
      { label: "Large Format Posters",   cat: "Large Format Posters" },
      { label: "Styrene Signs",          cat: "Styrene Signs" },
      { label: "Display Board / POP",    cat: "Display Board / POP" },
      { label: "Canvas",                 cat: "Canvas" },
      { label: "X-Frame Banners",        cat: "X-Frame Banners" },
      { label: "A-Frame Signs",          cat: "A-Frame Signs" },
      { label: "Wall Decals",            cat: "Wall Decals" },
      { label: "A Frame Stands",         cat: "A Frame Stands" },
      { label: "H Stands for Signs",     cat: "H Stands for Signs" },
    ],
  },
  {
    label: "Labels & Packaging",
    subs: [
      { label: "Square Cut Labels", cat: "Square Cut Labels / Stickers" },
      { label: "Roll Labels",       cat: "Roll Labels / Stickers" },
      { label: "Covid-19 Decals",   cat: "Covid-19-Decals-" },
    ],
  },
  {
    label: "Promotions & Apparel",
    subs: [],
  },
];

// Attach slug + groupLink so every group has a stable, unique key that both
// the default and the custom (Firestore) layer can reference identically.
export const DEFAULT_NAV_GROUPS = RAW_DEFAULT_GROUPS.map(g => ({
  ...g,
  slug: slugify(g.label),
  groupLink: "/products?group=" + encodeURIComponent(g.label),
}));

export function catLink(cat) {
  return `/products?cat=${encodeURIComponent(cat)}`;
}
